import { jsx as a, jsxs as N } from "react/jsx-runtime";
import { useFloating as A } from "../../node_modules/.pnpm/@floating-ui_react@0.27.16_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@floating-ui/react/dist/floating-ui.react.js";
import { clsx as c } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useRef as F, useState as y } from "react";
import { useEscapeKey as R } from "../../utils/use-escape-key.js";
import { useFocusOutside as _ } from "../../utils/use-focus-outside.js";
import { RocheUIMainNavigationBlock as C } from "../main-navigation-block/roche-main-navigation-block.js";
import { isCurrentPage as I, hasActiveDescendant as S } from "../mobile-navigation/roche-mobile-navigation-helpers.js";
import e from "./roche-main-navigation-item.module.scss.js";
import { autoUpdate as E } from "../../node_modules/.pnpm/@floating-ui_dom@1.7.4/node_modules/@floating-ui/dom/dist/floating-ui.dom.js";
import { offset as M, shift as O, limitShift as U } from "../../node_modules/.pnpm/@floating-ui_react-dom@2.1.6_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.js";
const L = ({ link: t, currentPage: s }) => {
  const u = F(null), [n, f] = y(!1), { refs: o, floatingStyles: g, update: v } = A({
    placement: "bottom-start",
    middleware: [
      M({ mainAxis: 12, crossAxis: -16 }),
      O({
        crossAxis: !0,
        padding: 8,
        limiter: U({ offset: 8 })
      })
    ],
    whileElementsMounted: E
  }), p = () => {
    f(!1), requestAnimationFrame(() => {
      var i;
      (i = u.current) == null || i.focus();
    });
  };
  R(p, n), _(o.floating, n, p, o.domReference);
  const h = () => {
    requestAnimationFrame(() => v());
  }, b = () => {
    f((i) => !i);
  }, { nestedLinks: r, text: m, url: d } = t;
  if (!t.url)
    return /* @__PURE__ */ a(
      "li",
      {
        className: c(e["main-navigation-item"], e["main-navigation-item--separator"]),
        "aria-hidden": "true"
      }
    );
  const l = I(d, s);
  if (!(r != null && r.length))
    return /* @__PURE__ */ a(
      "li",
      {
        className: c(
          e["main-navigation-item"],
          l && e["main-navigation-item--active"],
          n && e["main-navigation-item--open"]
        ),
        children: /* @__PURE__ */ a(
          "a",
          {
            className: e["main-navigation-item__link"],
            href: d,
            "aria-current": l ? "page" : void 0,
            onClick: t.onClick,
            children: m
          }
        )
      }
    );
  const x = l || S(r, s);
  return /* @__PURE__ */ N(
    "li",
    {
      className: c(
        e["main-navigation-item"],
        n && e["main-navigation-item--open"],
        x && e["main-navigation-item--active"]
      ),
      children: [
        /* @__PURE__ */ a(
          "button",
          {
            ref: (i) => {
              o.setReference(i), u.current = i;
            },
            className: e["main-navigation-item__button"],
            "aria-expanded": n ? "true" : "false",
            "aria-controls": `submenu-${t.url}`,
            onClick: b,
            type: "button",
            children: m
          }
        ),
        /* @__PURE__ */ a(
          "div",
          {
            id: `submenu-${t.url}`,
            ref: o.setFloating,
            style: g,
            className: e["main-navigation-item__submenu"],
            role: "region",
            "aria-label": `${m} submenu`,
            children: /* @__PURE__ */ a(C, { root: t, currentPage: s, updateFlyoutPosition: h })
          }
        )
      ]
    }
  );
};
export {
  L as RocheUIMainNavigationItem
};
